import DefaultLayout from "@/layouts/DefaultLayout";
import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import client from "@/utils/api/client";
import { PostDetailResponse } from "@/web-client/api";
import { notFoundWrapper } from "@/utils/notFoundWrapper";
import usePost from "@/features/post/hooks/usePost";
import Error from "next/error";
import PostShowTemplate from "@/features/post/components/PostShowTemplate";

interface Props {
  id: number;
  initialPost: PostDetailResponse;
}

const PostPage: NextPage<Props> = ({ id, initialPost }): JSX.Element => {
  const { post, setPost, error } = usePost(id, initialPost);

  if (error) return <Error statusCode={404} label="ページが見つかりません" />;

  return (
    <DefaultLayout>
      <PostShowTemplate post={post} setPost={setPost} />
    </DefaultLayout>
  );
};

export default PostPage;

export const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
  return notFoundWrapper<Props>(async () => {
    const id = params.id as string;
    const response = await client.postsIdGet({ id: Number(id) });

    return {
      props: {
        id: Number(id),
        initialPost: response.data,
      },
      revalidate: 1,
    };
  });
};

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [],
  fallback: "blocking",
});
